import { render, staticRenderFns } from "./Sso.vue?vue&type=template&id=15df5b29&scoped=true"
import script from "./Sso.vue?vue&type=script&lang=js"
export * from "./Sso.vue?vue&type=script&lang=js"
import style0 from "./Sso.vue?vue&type=style&index=0&id=15df5b29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15df5b29",
  null
  
)

export default component.exports